type ActivityOption = {
  _id: string;
  title: string;
  projectType?: string | null;
  sicrediProtecId?: number | null;
};

function normalizedActivityKey(activity: ActivityOption) {
  const title = activity.title
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim()
    .toLocaleLowerCase("pt-BR");

  return `${activity.projectType ?? ""}:${title}`;
}

function hasNaturalCasing(title: string) {
  return title !== title.toLocaleUpperCase("pt-BR");
}

export function dedupeActivityOptions<T extends ActivityOption>(activities: readonly T[]): T[] {
  const byTitle = new Map<string, { activity: T; displayTitle: string }>();

  for (const activity of activities) {
    const key = normalizedActivityKey(activity);
    const existing = byTitle.get(key);
    if (!existing) {
      byTitle.set(key, { activity, displayTitle: activity.title });
      continue;
    }

    const displayTitle =
      hasNaturalCasing(existing.displayTitle) || !hasNaturalCasing(activity.title)
        ? existing.displayTitle
        : activity.title;
    const preferredActivity =
      existing.activity.sicrediProtecId === undefined && activity.sicrediProtecId !== undefined
        ? activity
        : existing.activity;

    byTitle.set(key, { activity: preferredActivity, displayTitle });
  }

  return Array.from(byTitle.values(), ({ activity, displayTitle }) => ({
    ...activity,
    title: displayTitle,
  }));
}
